import React from "react";
import {
  Popover, PopoverTrigger, PopoverContent, PopoverArrow,
  PopoverCloseButton, PopoverBody, Portal,
  PopoverHeader,
} from "@chakra-ui/react";
import { FaRegQuestionCircle } from "react-icons/fa";

interface HelpIconProps {
  header?: React.ReactNode;
  children: React.ReactNode;
  size?: string;
  placement?: "top-start" | "top" | "top-end" | "bottom-start" | "bottom" | "bottom-end" | "right" | "left" | "auto";
  width?: string;
}

const HelpIcon: React.FC<HelpIconProps> = ({
  header,
  children,
  size = "30px",
  placement = "top-start",
  width = "500px",
}) => {
  return (
    <Popover placement={placement}>
      <PopoverTrigger>
        <button style={{ background: 'none', border: 'none', padding: 0 }}>
          <FaRegQuestionCircle size={size} cursor="pointer" />
        </button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent width={width} bgColor="#fffff0">
          <PopoverArrow />
          {header &&
            <PopoverHeader width={Number(width.replace("px", "")) - 20}>{header}</PopoverHeader>
          }
          <PopoverCloseButton />
          <PopoverBody pr={8} style={{ whiteSpace: 'pre-wrap' }}>
            {children}
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default HelpIcon;
